<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" formName="RloapplicationFilterForm">
  <div class="header">
    <div class="primary-header">
      <fpx-button className="back" btnType="button" label="Back" (onClick)="_helper.closeFilter()"></fpx-button>
      <div class="title">Filter</div>
    </div>

    <fpx-button className="close" btnType="button" (onClick)="_helper.closeFilter()"></fpx-button>

  </div>
  <box class="entry-form">
    <fpx-fieldset class="textBoxGroup">
      <app-name-control class="col-md-4 sbc-name" formControlName="applicantName" label="Applicant Name"></app-name-control>
      <app-app-ref-control class="col-md-4" formControlName="arn" label="ARN"></app-app-ref-control>
    </fpx-fieldset>

    <fpx-fieldset class="checkBoxGroup">
      <!-- <app-application-filter-type-control class="col-md-4" formControlName="type"
        label="Type"></app-application-filter-type-control> -->

      <app-application-filter-period-control class="col-md-4" formControlName="period"
        label="Period"></app-application-filter-period-control>

      <app-application-filter-stage-control class="col-md-4" formControlName="stage"
        label="Stage"></app-application-filter-stage-control>

      <app-application-filter-tat-overdue-control class="col-md-4" formControlName="tat"
        label="TAT Overdue"></app-application-filter-tat-overdue-control>
    </fpx-fieldset>
  </box>
  <footer class="form-actions">
    <fpx-button className="secondary" btnType="button" label="Clear" (onClick)="_helper.clearFilter()"></fpx-button>
    <!-- <fpx-button [disable]="!_helper._rloapplicationService.filterApplied" className="primary" btnType="button" label="Apply" (onClick)="_helper.applyFilter()"></fpx-button> -->
    <fpx-button className="primary" btnType="button" label="Apply" (onClick)="_helper.applyFilter()"></fpx-button>
  </footer>
</form>
